// import React from 'react'
// import '../Styles/Copyrights.css'

// export const Copyrights = () => {
//   return (
//     <div className='Copyrights-container'>
//         <p>© 2025 Prasiddh – SAAR Asset Management. All rights reserved.</p>
//         <a><p>+91 9986 800 600</p></a>
//         <p>Download Brochure</p>
//         <p>Privacy Policy</p>
//         <p>Terms of Service</p>
//         <p>Cookies Settings</p>
//     </div>
//   )
// }

import React from 'react';
import '../Styles/Copyrights.css';
import {
  getCampaignId,
  getConversionLabel,
  gtag_report_conversion,
} from './ConversionHandler';

export const Copyrights = () => {
  const campaignId = getCampaignId();

  const handlePhoneClick = () => {
    const label = getConversionLabel('phone', campaignId);
    console.log('📞 Phone text clicked - Conversion Label:', label);
    gtag_report_conversion('tel:+919986800600', label);
  };

  const handleBrochureDownload = () => {
    const label = getConversionLabel('form', campaignId);
    const brochureUrl = 'https://secondinnings.in/Broucher/Prasiddh_broucher.pdf';

    console.log('📥 Brochure text clicked - Conversion Label:', label);

    const callback = () => {
      console.log('✅ Conversion recorded. Opening brochure...');
      window.open(brochureUrl, '_blank');
    };

    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: label,
        value: 1.0,
        currency: 'INR',
        event_callback: callback,
      });
    } else {
      console.warn('⚠️ gtag not available. Opening brochure directly.');
      window.open(brochureUrl, '_blank');
    }
  };

  return (
    <div className='Copyrights-container'>
      <p>© 2025 Prasiddh – SAAR Assets Management. All rights reserved.</p>
      
      <p onClick={handlePhoneClick} className="clickable-text">+91 9986 800 600</p>
      
      <p onClick={handleBrochureDownload} className="clickable-text">Download Brochure</p>
      
      <p>Privacy Policy</p>
      <p>Terms of Service</p>
      <p>Cookies Settings</p>
    </div>
  );
};
